(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Blighted Battleaxe": {
      abilities: [
        equip({ energy: 1, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      attachedTriggers: [
        {
          on: "endOfTurn",
          optional: false,
          label: "At the end of your turn, if I didn't conquer this turn, unattach this and deal 4 to me",
          targets: [],
          program: [{ op: "detachVia" }, { op: "deal", to: "source", n: 4 }],
          you: true,
          condSpec: { k: "notConqueredThisTurn" },
        },
      ],
    },

    "Grim Apothecary": {
      play: [
        {
          op: "may",
          prompt: "You may return a friendly unit at a battlefield to its owner's hand?",
          then: [
            {
              op: "choose",
              bind: "t1",
              spec: { type: "unit", friendly: true, atBf: true },
              prompt: "Return to hand...",
            },
            { op: "toHand", to: "$t1" },
          ],
        },
      ],
    },

    "Hextech Gauntlets": {
      abilities: [
        equip({ energy: 3, pips: 0, anyPower: 1, domains: null }, { energyLessByTargetMight: "t" }),
      ],
      attachedTriggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, if you assigned 3 or more excess damage, draw 1",
          targets: [],
          program: [{ op: "draw", n: 1 }],
          selfBf: true,
          you: true,
          condSpec: { k: "excessDamageAtLeast", n: 3 },
        },
      ],
    },

    "Inferna": {},

    "Inviolus Vox": {
      triggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, give a friendly unit +8 :rb_might: this turn",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", friendly: true },
              prompt: "Give +8 Might to...",
            },
          ],
          program: [buff("$t1", 8)],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Jhin, Murderous Artist": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move, [Add] :rb_energy_1::rb_rune_rainbow:",
          targets: [],
          program: [{ op: "addResources", res: { energy: 1, anyPower: 1 } }],
          self: true,
        },
      ],
    },

    "Lord Broadmane": {
      play: [
        {
          op: "grant",
          spec: { type: "unit", friendly: true, other: true, here: true },
          keyword: "assault",
          dur: "turn",
        },
      ],
    },

    "Mischievous Marai": {
      play: [
        {
          op: "if",
          cond: { k: "ctxBf" },
          then: [
            {
              op: "choose",
              bind: "t1",
              spec: { type: "unit", enemy: true, here: true },
              prompt: "Deal 2 to...",
            },
            { op: "deal", to: "$t1", n: 2 },
          ],
        },
      ],
    },

    "Rengar, Unseen": {},

    "Scorchclaw": {
      selfMightSpecs: [{ n: 1, cond: { k: "xp", n: 3 } }],
      entersReadyCond: { k: "xp", n: 3 },
    },

    "Sharkling": {},

    "Square Up": {
      play: [{ op: "grant", to: "$t1", keyword: "assault", kwValue: 4, dur: "turn" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give [Assault] to..." }],
      repeatCosts: [
        { cost: { energy: 0, pips: 0, anyPower: 0, domains: null }, costDiscard: 1 },
      ],
    },

    "Upstage Comedy": {
      play: [{ op: "ready", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Ready..." }],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Vault Breaker": {
      play: [
        { op: "grant", to: "$t1", keyword: "assault", kwValue: 2, dur: "turn" },
        { op: "grant", to: "$t1", keyword: "ganking", dur: "turn" },
      ],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit" },
          prompt: "Give [Assault] and [Ganking] to...",
        },
      ],
    },

    "Xerath, Freed": {
      abilities: [
        {
          cost: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] },
          exhausts: true,
          needBf: true,
          label: "Xerath, Freed",
          targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Deal 3 to..." }],
          program: [{ op: "deal", to: "$t1", n: 3 }],
        },
      ],
    },

    "Yeti Brawler": {
      triggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, if you assigned 3 or more excess damage, play two Gold gear tokens exhausted",
          targets: [],
          program: [{ op: "token", name: "Gold", n: 2, loc: "base", exhausted: true }],
          selfBf: true,
          you: true,
          condSpec: { k: "excessDamageAtLeast", n: 3 },
        },
      ],
    },

    "Curtain Call": {
      play: [{
        op: "modalOnce",
        prompt: "Choose one you haven't already chosen",
        modes: [
          { label: "Draw 1", then: [{ op: "draw", n: 1 }] },
          {
            label: "Deal 2 to a unit at a battlefield",
            then: [
              { op: "choose", bind: "_cc2", spec: { type: "unit", atBf: true }, prompt: "Deal 2 to which unit at a battlefield?" },
              { op: "deal", to: "$_cc2", n: 2 },
            ],
          },
          {
            label: "Deal 3 to a unit at a base",
            then: [
              { op: "choose", bind: "_cc3", spec: { type: "unit", inBase: true }, prompt: "Deal 3 to which unit at a base?" },
              { op: "deal", to: "$_cc3", n: 3 },
            ],
          },
          {
            label: "Give a unit at a battlefield -4 Might this turn",
            then: [
              { op: "choose", bind: "_cc4", spec: { type: "unit", atBf: true }, prompt: "Give which unit at a battlefield -4 Might this turn?" },
              buff("$_cc4", -4),
            ],
          },
        ],
      }],
      repeatCosts: [
        { cost: { energy: 1, pips: 0, anyPower: 0, domains: null } },
        { cost: { energy: 0, pips: 0, anyPower: 1, domains: null } },
        { cost: { energy: 1, pips: 0, anyPower: 1, domains: null } },
      ],
    },

    "Pridestalker": {
      triggers: [{
        on: "played",
        you: true,
        label: "play a unit: give a unit +1 Might",
        condSpec: { k: "evType", type: "unit" },
        targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Give which unit +1 Might this turn?" }],
        program: [buff("$t", 1)],
      }],
    },

    "Thrill of the Hunt": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Banish which friendly unit and replay it?" }],
      play: [
        { op: "banish", to: "$t" },
        { op: "playFrom", to: "$t", waive: "all", anyBf: true },
      ],
    },

    "Bloodharbor Ripper": {
      abilities: [{
        cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
        exhausts: true,
        label: "Bloodharbor Ripper",
        targets: [{
          bind: "t",
          spec: { type: "unit", friendly: true, atBf: true },
          prompt: "Return which friendly unit at a battlefield to its owner's hand?",
        }],
        program: [
          { op: "toHand", to: "$t" },
          { op: "token", name: "Gold", exhausted: true },
        ],
      }],
    },

    "Death from Below": {
      targets: [{ bind: "t", spec: { type: "unit", atBf: true }, prompt: "Kill which unit at a battlefield?" }],
      play: [
        { op: "setVarMight", varKey: "dfbMight", from: "$t" },
        { op: "kill", to: "$t" },
        {
          op: "if",
          cond: { k: "not", cond: { k: "varAtLeast", key: "dfbMight", n: 4 } },
          then: [{
            op: "delayed",
            on: "spellResolved",
            forPlayer: "controller",
            label: "Death from Below: play it from your trash",
            program: [
              { op: "may", prompt: "Play Death from Below from your trash for 1 rainbow?", skip: 3 },
              {
                op: "choose", bind: "dfb", min: 0,
                spec: { zone: "trash", type: "spell", tag: "Pyke", maxEnergy: 4, maxPips: 1 },
                prompt: "Play which copy of Death from Below from your trash?",
              },
              { op: "payCost", cost: { energy: 0, pips: 0, anyPower: 1, domains: null }, skipOnFail: 1 },
              { op: "playFrom", to: "$dfb", waive: "all" },
            ],
          }],
        },
      ],
    },

    "Piltover Enforcer": {
      triggers: [{
        on: "conquer",
        you: true,
        optional: true,
        exhaustSelf: true,
        label: "conquer with 3+ excess damage: exhaust me to ready a unit",
        condSpec: { k: "and", conds: [{ k: "selfReady" }, { k: "excessDamageAtLeast", n: 3 }] },
        targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Ready which unit?" }],
        program: [
          { op: "exhaust", to: "source" },
          { op: "ready", to: "$t" },
        ],
      }],
    },

    "Arena Kingpin": {
      entersReady: true,
      abilities: [
        {
          label: "Exhaust: give a unit +3 Might this turn",
          exhausts: true,
          targets: [
            { bind: "t", spec: { type: "unit" }, prompt: "Give which unit +3 Might this turn?" },
          ],
          program: [buff("$t", 3)],
        },
      ],
    },

    "Prepared Neophyte": {
      selfMightSpecs: [{ n: 4, cond: { k: "spellSpentAtLeast", n: 4 } }],
    },

    "Revna the Lorekeeper": {
      triggers: [
        {
          on: "finalizedCard",
          label: "spell played for 4 or more: ready me",
          condSpec: {
            k: "and",
            conds: [
              { k: "evYou" },
              { k: "evType", type: "spell" },
              { k: "spellSpentAtLeast", n: 4 },
            ],
          },
          program: [{ op: "ready", to: "source" }],
        },
      ],
    },

    "Smite": {
      targets: [
        {
          bind: "t",
          spec: { type: "unit", atBf: true },
          prompt: "Deal 3 to which unit at a battlefield?",
        },
      ],
      play: [
        { op: "deal", to: "$t", n: 3 },
        {
          op: "if",
          cond: { k: "targetDead", bind: "t" },
          then: [{ op: "banish", to: "$t" }],
        },
      ],
    },

    "Towering Pairofant": {
      entersReadyCond: { k: "unitDiedThisTurn" },
    },

    "Monster Harpoon": {
      targets: [
        {
          bind: "t",
          spec: { type: "unit", atBf: true },
          prompt: "Deal damage to which unit at a battlefield?",
        },
      ],
      play: [
        {
          op: "if",
          cond: { k: "count", spec: { zone: "facedown", friendly: true }, n: 1 },
          then: [{ op: "deal", to: "$t", n: 4 }],
          else: [{ op: "deal", to: "$t", n: 2 }],
        },
      ],
    },

    "Right of Conquest": {
      play: [
        { op: "draw", n: 1 },
        { op: "draw", n: { count: { zone: "battlefield", friendly: true } } },
      ],
    },

    "Katarina, Reckless": {
      triggers: [
        {
          on: "played",
          you: true,
          label: "card played from face down: deal 2 to an enemy unit",
          condSpec: { k: "evFromFacedown" },
          targets: [
            {
              bind: "e",
              spec: { type: "unit", enemy: true },
              min: 0,
              prompt: "Deal 2 to which enemy unit?",
            },
          ],
          program: [{ op: "deal", to: "$e", n: 2 }],
        },
        {
          on: "finalizedCard",
          you: true,
          label: "spell played from face down: deal 2 to an enemy unit",
          condSpec: { k: "and", conds: [{ k: "evFromFacedown" }, { k: "evType", type: "spell" }] },
          targets: [
            {
              bind: "e",
              spec: { type: "unit", enemy: true },
              min: 0,
              prompt: "Deal 2 to which enemy unit?",
            },
          ],
          program: [{ op: "deal", to: "$e", n: 2 }],
        },
        {
          on: "hidden", you: true,
          label: "you hide a card: ready me",
          program: [{ op: "ready", to: "source" }],
        },
      ],
    },

    "Pyke, Dockside Butcher": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Pyke, Dockside Butcher",
          cost: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] },
          entersReady: true,
          then: [buff("source", 2)],
          thenTargets: [],
        },
      ],
    },

    "Red Brambleback": {
      conquerAgainHere: 1,
      triggers: [
        {
          on: "unitConquer",
          self: true,
          label: "when I conquer, buff a friendly unit",
          targets: [
            {
              bind: "b",
              spec: { type: "unit", friendly: true },
              prompt: "Buff which friendly unit?",
            },
          ],
          program: [{ op: "buff", to: "$b" }],
        },
      ],
    },

    "Vi, Hotheaded": {
      abilities: [
        {
          cost: { energy: 2, pips: 1, anyPower: 0, domains: ["fury"] },
          label: "Double my Might this turn",
          targets: [],
          program: [{ op: "grant", to: "source", might: { mightOf: "source" }, dur: "turn" }],
        },
      ],
    },

    "Dancing Grenade": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Deal 2 to which unit?" }],
      play: [
        { op: "deal", to: "$t", n: { namedDamage: true, plus: 2 }, countByName: true },
        { op: "setVarPlayer", of: "$t", varKey: "dgWho" },
        {
          op: "delayed", on: "spellResolved", forEachSelf: true, carryVars: ["dgWho"],
          label: "Dancing Grenade: its controller may play it again",
          program: [{ op: "replayFromTrash", whoVar: "dgWho", cost: { anyPower: 1 } }],
        },
      ],
    },

    "Virtuoso": {
      triggers: [{
        on: "finalizedCard", you: true, optional: true,
        label: "spell played for 4+ Energy: banish it with me",
        condSpec: {
          k: "and",
          conds: [{ k: "evType", type: "spell" }, { k: "lastSpellSpentAtLeast", n: 4 }],
        },
        program: [{ op: "banishChainSpell" }],
      }],
      banishedWithPayoff: {
        n: 4,
        label: "four spells banished: trash them, channel 4, draw 1",
        program: [
          { op: "trashBanishedWith" },
          { op: "channel", n: 4 },
          { op: "draw", n: 1 },
        ],
      },
    },

    "Fresh Beans": {
      triggers: [{
        on: "played", you: true, optional: true, exhaustSelf: true,
        label: "unit played during a showdown: exhaust this to draw 1",
        condSpec: {
          k: "and",
          conds: [{ k: "evType", type: "unit" }, { k: "showdownActive" }, { k: "selfReady" }],
        },
        program: [
          { op: "exhaust", to: "source" },
          { op: "draw", n: 1 },
        ],
      }],
    },

    "Lotus Trap": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Double all damage dealt to which unit this turn?" }],
      play: [{ op: "amplifyDamage", to: "$t", times: 2, dur: "turn" }],
    },

    "Undying Legion": {
      flowCost: {
        energy: 3, pips: 1, anyPower: 0, domains: ["fury"],
        allowNonSpell: true,
        cond: { k: "legion", n: 1 },
      },
    },
  });
})();
